<script>
import { mapActions } from "vuex";
import { required, email } from '@vuelidate/validators';
import Customer from "@/models/Customer.vue";
import BaseCustomerGroupDialogSelector from "@/components/shared/BaseDialogSelectors/BaseCustomerGroupDialogSelector.vue";

export default {
  extends: Customer,
  components: {
    BaseCustomerGroupDialogSelector,
  },
  computed: {
    title() {
      return this.id ? `Edit ${this.modelName}` : `Create ${this.modelName}`;
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    ...mapActions("customers", ["upsertCustomer"]),
    ...mapActions("application", ["setIsConfirmLoading", "warnValidation"]),

    async show() {
      this.initialize();
      this.showModal = true;
    },

    async upsert(e) {
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.warnValidation();
        return;
      } else {
        this.setIsConfirmLoading(true);
        try {
          const res = await this.upsertCustomer(this.customer);
          this.$emit("upserted", res.data?.data);
          this.showModal = false;
          this.v$.$reset();
        } catch {
        } finally {
          this.setIsConfirmLoading(false);
        }
      }
    },
  },
  watch: {
    showModal() {
      this.v$.$reset();
    }
  },
  validations() {
    return this.showModal
      ? {
          first_name: { required },
          email: { email },
        }
      : { };
  },
};
</script>

<template>
  <base-modal v-model="showModal" :title="title" @upsert="upsert">
    <form @submit.prevent="upsert">
      <Label>Customer Type</Label>
      <div class="d-block d-sm-flex gap-4 mb-2">
        <b-button :variant="is_company ? 'secondary' : 'primary'" class="w-100" @click="is_company = false">Individual</b-button>
        <b-button :variant="is_company ? 'primary' : 'secondary'" class="w-100 mt-2 mt-sm-0" @click="is_company = true">Company</b-button>
      </div>
      <div class="row mb-2 gap-2 gap-sm-0" v-if="is_company">
        <div class="col-sm-8 col-xl-7">
          <base-input label="Name" type="text" v-model="first_name" :validation="v$.first_name" required />
        </div>
        <div class="col-sm-4 col-xl-5">
          <base-input label="Tax Number" type="text" v-model="tax_number" />
        </div>
      </div>
      <div class="row mb-2 gap-2 gap-sm-0" v-else>
        <div class="col-sm-6">
          <base-input label="First Name" type="text" v-model="first_name" :validation="v$.first_name" required />
        </div>
        <div class="col-sm-6">
          <base-input label="Last Name" type="text" v-model="last_name" />
        </div>
      </div>
      <div class="row mb-2 gap-2 gap-sm-0">
        <div class="col-sm-7">
          <base-input
            label="Email"
            type="text"
            v-model="email"
            :validation="v$.email"
          />
        </div>
        <div class="col-sm-5">
          <base-input
            label="Contact Number"
            type="text"
            v-model="contact_number"
          />
        </div>
      </div>
      <div class="row mb-2  gap-2 gap-sm-0">
        <!-- <div class="col-sm-7"> -->
          <BaseCustomerGroupDialogSelector v-model="customer_group" disableAdd disableModals />
        <!-- </div>
        <div class="col-sm-5">

        </div> -->
      </div>
    </form>
  </base-modal>
</template>
